import styled, { css } from 'styled-components'

import {
  ResponsiveImage,
  TypeStyle,
  fromLg,
  fromMd,
  skeletonAnimationCss,
  timingSlower,
  untilLg,
} from '@syconium/little-miss-figgy'

import { NextLink } from '../../../../../app/_components/navigation/NextLink'
import {
  CrossedOutPrice,
  DiscountPrice,
  Price,
} from '../../../../../brunswick/components/PriceDisplay/styles'
import {
  FitSection,
  SizeSection,
} from '../../../../../brunswick/components/VariantAttributeSelectors/styles'
import { fadeIn } from '../../../../../brunswick/styles/shared'

export const Body = styled.div`
  padding: 0 ${o => o.theme.spacing(4)};
  ${fromMd} {
    padding: 0 ${o => o.theme.spacing(6)};
  }
`

export const LoadingSpinnerWrapper = styled.div`
  align-items: center;
  animation: ${fadeIn} ${timingSlower} ease 0s 1 both;
  display: flex;
  height: 50vh;
  justify-content: center;

  ${fromLg} {
    height: 75vh;
  }
`

export const TilesList = styled.ul`
  margin-top: 12px;

  > * {
    border: 1px solid ${o => o.theme.color.deprecated.stoneLight};
    border-radius: 3px;
  }

  > * + * {
    margin-top: 16px;
  }

  ${fromLg} {
    margin-top: 21px;

    > * {
      border-left: none;
      border-radius: 0;
      border-right: none;

      &:not(:last-of-type) {
        border-bottom: none;
      }
    }

    > * + * {
      margin-top: 0;
    }
  }
`

export const Tile = styled.div`
  display: flex;
  overflow: hidden;
  ${untilLg} {
    align-items: stretch;
  }
  ${fromLg} {
    padding: 17px 0;
    align-items: flex-start;
  }
`

const tileTextCss = css`
  flex: 1;
  padding: 12px;

  ${untilLg} {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
  }

  ${fromLg} {
    padding-left: 28px;
  }
`

export const TileTextLink = styled(NextLink)`
  ${tileTextCss};
`

export const TileTextSkeleton = styled.div`
  ${tileTextCss};
`

export const PriceAndColor = styled.div`
  align-items: flex-end;
  display: flex;
  margin-top: 4px;

  ${CrossedOutPrice},
  ${DiscountPrice},
  ${Price} {
    font-size: 11px;
    line-height: 1.5;

    ${fromLg} {
      font-size: 12px;
    }
  }
`

export const ColorName = styled(TypeStyle.HeadlineMicro)`
  margin-left: 8px;

  ${fromLg} {
    display: none;
  }
`

export const QuickBuyButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: ${o => o.theme.spacing(2)};

  ${fromLg} {
    display: none;
  }
`

export const DesktopContents = styled.div`
  display: none;

  ${fromLg} {
    display: flex;
    flex: 3;
    padding-top: ${o => o.theme.spacing(3)};
  }
`

export const VariantAttributeSelectorsWrapper = styled.div`
  flex: 2;

  ${FitSection} {
    margin-top: 18px;
  }

  ${SizeSection} {
    margin-top: 10px;
  }
`

export const DesktopButtonCtaWrapper = styled.div`
  flex: 1;
  padding-left: 16px;
`

export const ShopTheLookTileImage = styled(ResponsiveImage)`
  height: 85px;
  width: 85px;

  ${fromLg} {
    height: 250px;
    width: 200px;
  }
`

export const ShopTheLookTileSkeletonImage = styled.div`
  ${skeletonAnimationCss};
  height: 85px;
  width: 85px;

  ${fromLg} {
    height: 250px;
    width: 200px;
  }
`
